module.exports = __webpack_public_path__ + "static/media/perk-4-new.5b13866c.jpg";